import React, { useState } from "react";
import Modal from "../modal/modal";
import PositionEnum from "../../enums/position.enum";
import { PathwayTypeBadge, SizeEnum } from "../../wne-mpng-components-mf";
import "./deactivate-modal.scss";
export interface IDeactivateModalProps {
  isVisible: boolean;
  subject: string;
  onDeactivatePlacement: () => void;
  onClose: (deactivate) => void;
  isDomainPlacementEnabled: boolean;
  hasIPlusMLicense: boolean;
  pathwayType: string;
}

const DeactivateModal = (props: IDeactivateModalProps) => {
  const handleModalClose = () => {
    props.onClose(false);
  };
  const handleDeactivate = () => {
    props.onDeactivatePlacement();
  };
  return (
    <Modal
      className=""
      size={SizeEnum.LARGE}
      vPosition={PositionEnum.CENTER}
      showModal={props.isVisible}
      handleClose={handleModalClose}
      title={
        <div className="title-container">
          <div className="title">Deactivate {props.subject} Learning Path?</div>
          {props.hasIPlusMLicense && props.subject.toLocaleLowerCase() == "math" && (
            <PathwayTypeBadge pathwayType={props.pathwayType} />
          )}
        </div>
      }
      body={
        <div>
          <div className="deactivate-msg">
            Deactivating the {props.subject} learning path will remove student access to the pathway. Would you like to
            continue?
          </div>
          <div className="footer-buttons">
            <button className="cancel-button" onClick={handleModalClose}>
              Cancel
            </button>
            <button className="deactivate-button" onClick={handleDeactivate}>
              Deactivate
            </button>
          </div>
        </div>
      }
      showClose={true}
      scrollable={false}
      backdrop="static"
    />
  );
};

export default DeactivateModal;
